import { Deg2Rad } from "../math/MathEx.js";
const MinGeoAltitude = -3.54; // In degree
const TransitionWidthGeo = 1.46; // In degree
const Correction = (pressure, temperature) => {
    return ((pressure / 1010) * 283) / (273 + temperature) / 60;
};
export const RefractionForwardCorrection = (altitude, pressure = 1013.0, temperature = 15.0) => {
    const correction = Correction(pressure, temperature);
    if (altitude > MinGeoAltitude) {
        const arg = altitude + 10.3 / (altitude + 5.11);
        return correction * (1.02 / Math.tan(arg * Deg2Rad) + 0.0019279);
    }
    if (altitude > MinGeoAltitude - TransitionWidthGeo) {
        const arg = MinGeoAltitude + 10.3 / (MinGeoAltitude + 5.11);
        const rm5 = correction * (1.02 / Math.tan(arg * Deg2Rad) + 0.0019279);
        return ((rm5 * (altitude - (MinGeoAltitude - TransitionWidthGeo))) /
            TransitionWidthGeo);
    }
    return 0;
};
